import React from 'react';
import { Typography, Progress } from 'antd';

const EbPageLoader = () => {
    return (
        <div className="d-flex flex-column text-center mx-auto eb-pageloader">
            <Typography.Text className="mb-1" strong>Redirecting...</Typography.Text>
            <Progress
                strokeColor={{ from: '#1890ff', to: '#D63B41', }}
                percent={100}
                status="active"
                showInfo={false}
                strokeWidth={18}
                style={{ borderRadius: 0 }}
                strokeLinecap="square"
            />
        </div>
    )
}

export { EbPageLoader };